import { useState, useEffect } from 'react';
import { get, list } from '../services/studentService';
import { Student } from '../types';

// TODO: replace dummy data with call to attendanceService.getMonthlyAttendance()
export const useStudents = (grade: string, section: string, status: string) => {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [students, setStudents] = useState<Student[]>(undefined);

  const fetchStudents = async () => {
    try {
      setIsLoading(true)
      const student: Student[] = await list(grade, section, status);
      setStudents(student);
      setIsLoading(false)
    } catch (err) {
      setError("Failed to load students.");
      setIsLoading(false)
    }
  }

  const reload = () => {
    fetchStudents();
  }

  return { students, isLoading, error, actions: { reload } };
};
